import { useTranslation } from 'react-i18next'

import { Text } from '@enechain/ecloud-designsystem'

/** 注記の種類ごとの文言 key と testid。 */
export type PlanStatusNoteKind = {
  noteKey: string
  testId: string
}

/**
 * 受付照合が OCCTO 呼び出し上限で停止中であることを示す注記 (plan-common AC-PLC-058)。
 * 需要調達計画・発電販売計画の一覧 status セルと詳細ヘッダの 4 面に置く。
 */
export const RECEIPT_CHECK_SUSPENDED_NOTE: PlanStatusNoteKind = {
  noteKey: 'page:planSubmission.receiptCheckSuspended.note',
  testId: 'receipt-check-suspended-note',
}

/**
 * OCCTO と通信できず自動で再送している「処理中」 の計画の注記 (plan-common AC-PLC-036)。
 * 需要調達計画の一覧 status セルと詳細ヘッダに置く。AC-PLC-058 の停止中は backend が
 * `send_retrying` を false で返すので、上の注記と同時には出ない。
 */
export const SEND_RETRYING_NOTE: PlanStatusNoteKind = {
  noteKey: 'page:planSubmission.sendRetrying.note',
  testId: 'send-retrying-note',
}

type Props = PlanStatusNoteKind & {
  /**
   * 表示するか。backend が判定して返す値 (`receipt_check_suspended_by_call_limit` /
   * `send_retrying`) をそのまま渡す (frontend で status 等の追加判定はしない)。
   */
  visible: boolean
}

/**
 * 計画の提出ステータス (`PlanSubmissionStatusBadge`) の隣に添える補足テキスト。
 *
 * エラー表示ではない状態の説明 (AC-PLC-036 ※: 再送中はエラー表示を出さない) なので、
 * Alert やトーストにせず、中程度の強調のテキストで出す。`visible` が false なら
 * 何も描画しない。
 */
export const PlanStatusNote = ({
  noteKey,
  testId,
  visible,
}: Props): React.ReactElement | null => {
  const { t } = useTranslation()

  if (!visible) {
    return null
  }

  return (
    <Text
      as="span"
      display="inline-block"
      verticalAlign="middle"
      marginLeft={2}
      color="Text.midEmphasis"
      fontSize="sm"
      data-testid={testId}
    >
      {t(noteKey)}
    </Text>
  )
}
